import React from 'react';
import { TooltipsContext } from '../../contexts/TooltipsContext';

/* Rallume les infobulles pour un contrôle du panneau de droite, où elles sont
   coupées par défaut (cf. TooltipsContext) : déplacer avant/arrière, position
   libre, rotation, mise en forme du texte. Aucun élément DOM ajouté. */
const KeepTooltip = ({ children }) => (
  <TooltipsContext.Provider value>{children}</TooltipsContext.Provider>
);

export default KeepTooltip;
